"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M16.5 15H3.5C3.224 15 3 15.224 3 15.5V17C3 17.553 3.447 18 4 18H16C16.553 18 17 17.553 17 17V15.5C17 15.224 16.776 15 16.5 15ZM14.5 12H5.5C5.224 12 5 11.776 5 11.5C5 11.224 5.224 11 5.5 11H14.5C14.776 11 15 11.224 15 11.5C15 11.776 14.776 12 14.5 12ZM5.5 9H10.5C10.776 9 11 9.224 11 9.5C11 9.776 10.776 10 10.5 10H5.5C5.224 10 5 9.776 5 9.5C5 9.224 5.224 9 5.5 9ZM15 2H5C3.896 2 3 2.896 3 4V13.5C3 13.776 3.224 14 3.5 14H16.5C16.776 14 17 13.776 17 13.5V4C17 2.896 16.104 2 15 2Z",
    fill: "#727B7F"
  }));
};